import React, { lazy, Suspense } from "react"
import { Route, Routes, Navigate, BrowserRouter as Router } from "react-router-dom"

import LoadingScreen from "@/components/ui/loading"
import ProtectedRoute from "./ProtectedRoute"

// Login ve dashboard ayrı chunk'larda: /login açılışında dashboard kodu
// indirilmez, dashboard'a doğrudan girenler de login kodunu indirmez.
const AuthRoutes = lazy(() => import("./AuthRoutes"))
const DashboardRoutes = lazy(() => import("./DashboardRoutes"))

const AppRoutes: React.FC = () => (
  <Router
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route element={<Navigate to="/login" />} path="/" />
        <Route element={<AuthRoutes />} path="/login/*" />
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardRoutes />} path="/dashboard/*" />
        </Route>
        {/* /dashboard prefix'i olmayan tüm path'leri dashboard'a yönlendir (örn. BE
            bir actionUrl'yi yanlış formatta dönerse beyaz ekran yerine NotFound gösterelim). */}
        <Route element={<Navigate to="/dashboard" replace />} path="*" />
      </Routes>
    </Suspense>
  </Router>
)

export default AppRoutes
